import styles from './PageHero.module.scss';

export interface PageHeroProps {
  title: string;
  subtitle: string;
}

export function PageHero({ title, subtitle }: PageHeroProps) {
  return (
    <div className={styles.hero}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  );
}
